import { OperationType } from '@com.amway.commerce/identity-username-config-v1-prod/Schema';
import type { IconPropInterface } from '@nextgen-web-framework/all';
import type { ReactNode } from 'react';
export enum UsernameFormatType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  EMAIL_PHONE = 'EMAIL_PHONE',
}
export interface Data {
  [key: string]: ReactNode | string | number | boolean | object;
}

export interface UsernameFieldValueType {
  emailOrPhoneWithoutCC?: string;
  countryCode?: string;
  amwayId?: string;
  hasError?: boolean;
}

export interface ValidateEmailPhoneType {
  emailOrPhoneWithoutCC: string;
  countryCode?: string;
}

export interface UsernameFieldProps {
  /**
   * default label for the form field in untouched or empty state
   *
   * @type {string}
   */
  defaultLabel?: string;

  /**
   * mobile label for the form field
   *
   * @type {string}
   */
  mobileLabel?: string;

  /**
   * email label for the form field
   *
   * @type {string}
   */
  emailLabel?: string;

  /**
   * dropdown label for the form field
   *
   * @type {string}
   */
  dropdownLabel?: string;

  /**
   * custom class
   *
   * @type {string}
   */
  className?: string;

  /**
   * executes when input is changed and returns UsernameFieldValueType
   *
   * @type {?(field: UsernameFieldValueType) => unknown}
   */
  onInputChangeCallback?: (field: UsernameFieldValueType) => unknown;

  /**
   * error msg to be shown
   *
   * @type {string}
   */
  error: string;

  /**
   * function to set set error msg
   *
   * @type {(err: string) => unknown}
   */
  setError: (err: string) => unknown;

  /**
   * flag to show error forcefully
   *
   * @type {?boolean}
   */
  forceError?: boolean;

  showErrorCallback?: (error: string) => unknown;

  clearErrorCallback?: () => unknown;
  checkUsernameConfig?: OperationType;
  disabled?: boolean;
  iconClassName?: string;
  inputIcon?: IconPropInterface;
  autoFocus?: boolean;
  onBlur?: (value: string) => void;
  resetValues?: boolean;
  autoPopulateValue?: string;
  dropDownDisableForSingleCountry?: boolean;
  inputWithDropdown?: boolean;
  placeholder?: string;
}
